<div
  class="reviewing-evaluation-wrapper"
  *ngIf="criterions$ | async as criterions"
>
  <mat-tab-group>
    <mat-tab *ngFor="let criterion of criterions | sort">
      <ng-template mat-tab-label>
        <mat-icon>info</mat-icon>
        <span class="mx-2">{{
          criterion | propertyLocalized : ["nameAr", "nameEn"] | async
        }}</span>
      </ng-template>
      <app-criterion-evaluation
        [disabled]="disabled || viewOnly"
        [model]="criterion"
        (valueChange)="updateValue()"
      ></app-criterion-evaluation>
    </mat-tab>
  </mat-tab-group>

  <app-general-report [criterions]="criterions"></app-general-report>
</div>
